export default __webpack_public_path__ + "images/5b4dd6ad6447232a1c3a9579296e7ff3-islam.webp";